<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Supervisões</h5>
    </div>

    <!-- Filtros -->
    <div class="d-flex mb-3" style="gap: 10px;">
      <input
        v-model="f.aluno"
        placeholder="Filtrar por Aluno"
        class="form-control"
        @input="filtrar"
      />
      <input
        v-model="f.instrutor"
        placeholder="Filtrar por Instrutor"
        class="form-control"
        @input="filtrar"
      />
      <input
        v-model="f.turma"
        placeholder="Filtrar por Turma"
        class="form-control"
        @input="filtrar"
      />

      <input
        v-model="f.por"
        placeholder="Filtrar por Realizada por"
        class="form-control"
        @input="filtrar"
      />

      <select
        v-model="f.status"
        class="form-control"
        @change="filtrar"
      >
        <option value="">Todos os status</option>
        <option value="PENDENTE">Pendente</option>
        <option value="AVALIADA">Avaliada - Aguardando Finalização</option>
        <option value="FINALIZADA">Finalizada</option>
        <option value="APROVADA_AGUARDANDO_EMAIL">Aprovada – Aguardando E-mail</option>
        <option value="EMAIL_ENVIADO">E-mail Enviado</option>
        <option value="CANCELADA">Cancelada</option>
      </select>
      <b-button variant="secondary" @click="limparFiltros" class="d-flex align-items-center justify-content-center">
        <i class="bi bi-funnel mr-2" title="Limpar Filtro"></i>
      </b-button>
    </div>

    <!-- Tabela nativa com ordenação -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="sort('id')">
              ID {{ arrow('id') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('aluno')">
              Aluno {{ arrow('aluno') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('instrutor')">
              Instrutor {{ arrow('instrutor') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('turma')">
              Turma {{ arrow('turma') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_solicitacao')">
              Data Solicitação {{ arrow('data_solicitacao') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('realizada')">
              Realizada {{ arrow('realizada') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('por')">
              Realizada por {{ arrow('por') }}
            </button>
          </th>          
          <th>
            <button class="btn btn-link p-0" @click="sort('data_realizacao')">
              Data Realização {{ arrow('data_realizacao') }}
            </button>
          </th>
          <!-- <th>
            <button class="btn btn-link p-0" @click="sort('status')">
              Status {{ arrow('status') }}
            </button>
          </th> -->

          <th class="text-end">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.aluno }}</td>
          <td>{{ item.instrutor }}</td>
          <td>{{ item.turma }}</td>
          <td>{{ globalUtils.formatarData(item.data_solicitacao) }}</td>
          <td>{{ item.realizada }}</td>
          <td>{{ item.por || '' }}</td>
          <td>{{ item.data_realizacao ? globalUtils.formatarData(item.data_realizacao) : '' }}</td>
          <!-- <td>{{ item.status }}</td> -->
          <td class="text-end">
            <!-- ações conforme estado -->
            <i
              v-if="
                item.mudar_nivel &&
                item.finalizada &&
                item.aprovado &&
                !item.email_avaliacao_enviado &&
                !item.cancelada
              "
              class="bi bi-envelope-plus text-primary mx-1"
              title="Enviar e-mail de troca de nível"
              @click="abrirEnviarEmail(item)"
            />
            <i
              v-if="item.email_avaliacao_enviado"
              class="bi bi-envelope-open text-success mx-1"
              :title="`E-mail enviado em ${globalUtils.formatarData(item.email_avaliacao_enviado_em)} por ${item.email_avaliacao_enviado_por || ''}`"
              @click="abrirEmailEnviado(item)"
            />
            <i
              v-if="item.cancelada"
              class="bi bi-x-circle text-secondary mx-1"
              title="Detalhes do Cancelamento"
              @click="abrirCancelarReadOnly(item)"
            />
            <i
              v-else-if="item.finalizada"
              class="bi bi-flag-fill text-success mx-1"
              title="Visualizar Supervisão"
              @click="item.mudar_nivel ? abrirMudarNivelReadOnly(item) : abrirOrientacaoReadOnly(item)"
            />
            <i
              v-if="item.finalizada && !item.cancelada && ehAdmin"
              class="bi bi-pencil-square text-warning mx-1"
              title="Editar Supervisão Finalizada"
              @click="abrirEdicaoFinalizada(item)"
            />

            <template v-if="!item.finalizada && !item.cancelada">
              <i
                v-if="item.mudar_nivel"
                :class="['bi bi-pencil-square mx-1', item.realizada === 'Sim' ? 'text-warning' : 'text-info']"
                title="Mudar Nível"
                @click="abrirMudarNivel(item)"
              />

              <i
                v-else
                :class="['bi bi-star mx-1', item.realizada === 'Sim' ? 'text-warning' : 'text-primary']"
                title="Orientação"
                @click="abrirOrientacao(item)"
              />
            </template>
            <i
              v-if="!item.cancelada && !item.finalizada"
              class="bi bi-x-circle text-danger mx-1"
              title="Cancelar Supervisão"
              @click="abrirCancelar(item)"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <!-- 1. Resumo de registros -->
      <div>
        Mostrando {{ startRow }} a {{ endRow }} de {{ totalItems }} registros
      </div>

      <!-- 2. Seletor de itens por página -->
      <div class="d-flex align-items-center" style="gap: .5rem;">
        <b-form-select
          v-model="limit"
          :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
          size="sm"
          style="width: 6rem"
        />
      </div>

      <!-- 3. Paginação propriamente dita -->
      <div class="d-flex align-items-center">
        <b-pagination
          v-model="page"
          :per-page="limit"
          :total-rows="totalItems"
          size="sm"
          limit="5"
        />
      </div>
    </div>

    <!-- Modais mantidos do original -->
    <SupervisaoOrientacao
      v-if="showModalOrientacao"
      :mostrar="showModalOrientacao"
      :supervisao="selectedSupervisao"
      :modo-visualizacao="modoVisualizacao"
      @close="closeModalOrientacao"
      @salvou="refreshList"
    />
    <SupervisaoMudarNivel
      v-if="showModalMudarNivel"
      :mostrar="showModalMudarNivel"
      :supervisao="selectedSupervisao"
      :modo-visualizacao="modoVisualizacao"
      @close="closeModalMudarNivel"
      @salvou="refreshList"
    />
    <SupervisaoCancelar
      v-if="showModalCancelar"
      :mostrar="showModalCancelar"
      :supervisao="selectedSupervisao"
      :modo-visualizacao="modoLeituraCancelar"
      @close="closeModalCancelar"
      @cancelado="refreshList"
    />
    <EmailTrocaNivel
      v-if="showModalEmailTrocaNivel"
      :visible="showModalEmailTrocaNivel"
      :readOnly="emailReadOnly"
      :aluno="selectedAlunoEmail"
      :empresaId="1"
      :supervisaoId="selectedSupervisaoIdEmail"
      @close="closeModalEmailTrocaNivel"
      @sent="refreshList"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed, getCurrentInstance } from 'vue';
import { useSortableTable } from '@/utils/useSortableTable';
import { usePermissions } from '@/composables/usePermissions';
import globalUtils from '@/utils/globalUtils';
import { BButton, BFormSelect, BPagination } from 'bootstrap-vue-next';
import SupervisaoOrientacao from '@/components/modals/SupervisaoOrientacao.vue';
import SupervisaoMudarNivel from '@/components/modals/SupervisaoMudarNivel.vue';
import SupervisaoCancelar from '@/components/modals/SupervisaoCancelar.vue';
import EmailTrocaNivel from '@/components/modals/EmailTrocaNivel.vue';

const instance = getCurrentInstance();

const ehAdmin = computed(() => {
  const gp = instance?.appContext?.config?.globalProperties;

  const perms = gp?.$globalState?.userPermissions || [];
  const perfil = gp?.$globalState?.userProfile;

  const asStr =
    typeof perfil === 'string'
      ? perfil
      : (perfil?.perfil || perfil?.role || '');

  const hasPerm = Array.isArray(perms)
    ? perms
        .map(s => String(s).toLowerCase().trim())
        .includes('administrador')
    : false;

  const byTitle = /(^|\s)(administrador|admin)(\s|$)/i.test(
    String(asStr || '').trim()
  );

  const isFlag = !!gp?.$globalState?.isAdmin;

  return hasPerm || byTitle || isFlag;
});

// setup composable
const {
  items,
  // totalPages,
  totalItems,
  page,
  limit,
  filters,
  // currentSort,
  sort,
  arrow,
  load,
  // goPrev,
  // goNext
} = useSortableTable(
  '/operacional/supervisoes/listagem',
  { key: 'data_solicitacao', order: 'desc' }
);

const f = computed(() => (filters?.value ? filters.value : filters));

// opções de itens por página
const pageOptions = [10, 15, 20, 25, 50];

const startRow = computed(() =>
  (page.value - 1) * limit.value + 1
)
const endRow = computed(() =>
  Math.min(page.value * limit.value, totalItems.value)
)


// recarrega sempre que mudar de página
watch(page, () => {
  load();
});

// ao trocar limite, volta à página 1 e recarrega
watch(limit, (nv, ov) => {
  if (nv !== ov) {
    page.value = 1;
    load();
  }
});

// inicializa filtros reativos
Object.assign(f.value, {
  aluno: '',
  instrutor: '',
  turma: '',
  por: '',
  status: ''
});

// modais e seleção
const showModalOrientacao  = ref(false);
const showModalMudarNivel  = ref(false);
const showModalCancelar    = ref(false);
const modoVisualizacao     = ref(false);
const modoLeituraCancelar  = ref(false);
const selectedSupervisao   = ref(null);

const showModalEmailTrocaNivel = ref(false);
const emailReadOnly = ref(true);
const selectedAlunoEmail = ref(null);
const selectedSupervisaoIdEmail = ref(null);

// permissões
const { fetchPermissions } = usePermissions();

// filtros e paginação
function filtrar() { page.value = 1; load(); }

function limparFiltros() {
  page.value = 1;
  Object.assign(f.value, {
    aluno: '',
    instrutor: '',
    turma: '',
    por: '',
    status: ''
  });
  load();
}

// modais
function abrirOrientacao(item) { selectedSupervisao.value = item; modoVisualizacao.value = false; showModalOrientacao.value = true; }
function abrirOrientacaoReadOnly(item) { selectedSupervisao.value = item; modoVisualizacao.value = true; showModalOrientacao.value = true; }
function abrirMudarNivel(item) { selectedSupervisao.value = item; modoVisualizacao.value = false; showModalMudarNivel.value = true; }
function abrirMudarNivelReadOnly(item) { selectedSupervisao.value = item; modoVisualizacao.value = true; showModalMudarNivel.value = true; }
function abrirCancelar(item) { selectedSupervisao.value = item; modoLeituraCancelar.value = false; showModalCancelar.value = true; }
function abrirCancelarReadOnly(item) { selectedSupervisao.value = item; modoLeituraCancelar.value = true; showModalCancelar.value = true; }
function closeModalOrientacao() { showModalOrientacao.value = false; selectedSupervisao.value = null; }
function closeModalMudarNivel() { showModalMudarNivel.value = false; selectedSupervisao.value = null; }
function closeModalCancelar() { showModalCancelar.value = false; selectedSupervisao.value = null; modoLeituraCancelar.value = false; }
function refreshList() {
  load();
  closeModalOrientacao();
  closeModalMudarNivel();
  closeModalEmailTrocaNivel();
}

function abrirEdicaoFinalizada(item) {
  selectedSupervisao.value = item;
  modoVisualizacao.value = false;

  if (item.mudar_nivel) {
    showModalMudarNivel.value = true;
  } else {
    showModalOrientacao.value = true;
  }
}

function abrirEmailEnviado(item) {
  // item = linha da listagem (supervisão)
  selectedSupervisaoIdEmail.value = item.id;
  emailReadOnly.value = true;

  // "aluno" mínimo esperado pelo EmailTrocaNivel (fallback de auditoria)
  selectedAlunoEmail.value = {
    id: item.aluno_id || item.alunoId || item.aluno_id, // se você não retorna aluno_id, não tem problema (o endpoint readOnly usa supervisaoId)
    nome: item.aluno,
    // fallback auditoria (o modal readOnly vai preferir sentEmail do endpoint)
    enviado_em: item.email_avaliacao_enviado_em || null,
    por: item.email_avaliacao_enviado_por || null,
    responsavel_email: '' // será preenchido pelo endpoint readOnly
  };

  showModalEmailTrocaNivel.value = true;
}

function abrirEnviarEmail(item) {
  selectedSupervisaoIdEmail.value = item.id;
  emailReadOnly.value = false;

  selectedAlunoEmail.value = {
    id: item.aluno_id || null,
    nome: item.aluno || '',
    responsavel_email: '' // será carregado via preview no modal
  };

  showModalEmailTrocaNivel.value = true;
}


function closeModalEmailTrocaNivel() {
  showModalEmailTrocaNivel.value = false;
  selectedAlunoEmail.value = null;
  selectedSupervisaoIdEmail.value = null;
}



// mount
onMounted(async () => {
  await fetchPermissions();

  Object.assign(f.value, {
    aluno: '',
    instrutor: '',
    turma: '',
    por: '',
    status: ''
  });
  page.value = 1;

  load();
});
</script>

<style scoped>
.same-height { height: 30px; padding: 6px 12px; font-size: .72rem; }

:deep(.pagination.pagination-sm .page-link) {
  padding: rem rem;
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}

</style>
